import Config from "./config";
import axios from "axios";

export class studentInfoApi {
  /*UPDATE*/
  async UpdateMessageDataNetwork(formDataSystemMessage) {
    var serviceUrl = "";
    serviceUrl = Config.REST_URL + "api/AskIT/UpdateMessageDataNetwork/";
    console.log("Service URL:" + serviceUrl);

    try {
      const res = await axios.post(serviceUrl, formDataSystemMessage);
      if (res.status === 200) {
        return res.data;
      } else {
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  async UpdateMessageDataEmail(formDataSystemMessage) {
    var serviceUrl = "";
    serviceUrl = Config.REST_URL + "api/AskIT/UpdateMessageDataEmail/";
    console.log("Service URL:" + serviceUrl);

    try {
      const res = await axios.post(serviceUrl, formDataSystemMessage);
      if (res.status === 200) {
        return res.data;
      } else {
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  async UpdateMessageDataSIS(formDataSystemMessage) {
    var serviceUrl = "";
    serviceUrl = Config.REST_URL + "api/AskIT/UpdateMessageDataSIS/";
    console.log("Service URL:" + serviceUrl);

    try {
      const res = await axios.post(serviceUrl, formDataSystemMessage);
      if (res.status === 200) {
        return res.data;
      } else {
      }
    } catch (error) {
      console.log(error.message);
    }
  }

   async UpdateMessageITNews(formDataSystemMessage) {
    var serviceUrl = "";
    serviceUrl = Config.REST_URL + "/api/AskIT/UpdateMessageITNews/";
    console.log("Service URL:" + serviceUrl);

    try {
      const res = await axios.post(serviceUrl, formDataSystemMessage);
      if (res.status === 200) {
        return res.data;
      } else {
      }
    } catch (error) {
      console.log(error.message);
    }
  }


    /*FETCH*/
  async fetchMessageDataNetwork() {
    var baseURL = Config.REST_URL + "api/AskIT/fetchMessageDataNetwork/";

    try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error fetching message data:", error);
      return "Error: Unable to fetch message data. Please check network connection.";
    }
  }

  async fetchMessageDataEmail() {
    var baseURL = Config.REST_URL + "api/AskIT/fetchMessageDataEmail/";

      try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error fetching message data:", error);
      return "Error: Unable to fetch message data. Please check network connection.";
    }
  }

  async fetchMessageDataSIS() {
    var baseURL = Config.REST_URL + "api/AskIT/fetchMessageDataSIS/";
  try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error fetching message data:", error);
      return "Error: Unable to fetch message data. Please check network connection.";
    }
  }

    async fetchITNews() {
    var baseURL = Config.REST_URL + "/api/AskIT/fetchITNews/";
  try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error fetching message data:", error);
      return "Error: Unable to fetch message data. Please check network connection.";
    }
  }


    /*DELETE*/
  async DeleteMessageDataNetwork() {
    var baseURL = Config.REST_URL + "api/AskIT/DeleteMessageDataNetwork/";

    try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error DELETING message data:", error);
      return "Error: Unable to DELETE message data. Please check network connection.";
    }
  }

  async DeleteMessageDataEmail() {
    var baseURL = Config.REST_URL + "api/AskIT/DeleteMessageDataEmail/";

      try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error DELETING message data:", error);
      return "Error: Unable to DELETE message data. Please check network connection.";
    }
  }

  async DeleteMessageDataSIS() {
    var baseURL = Config.REST_URL + "api/AskIT/DeleteMessageDataSIS/";
  try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error DELETING message data:", error);
      return "Error: Unable to DELETE message data. Please check network connection.";
    }
  }

async determineAlerts() {
    var baseURL = Config.REST_URL + "api/AskIT/determineAlerts/";
  try {
      return await axios.get(baseURL).then((res) => {
        return res.data;
      });
    } catch (error) {
      console.error("Error fetching message data status:", error);
      return "Error: Unable to fetch message data status. Please check network connection.";
    }
  }
  
} //END

export default studentInfoApi;
